import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useAuth } from '@/context/AuthContext';

import {
  AlertaErro,
  AuthShell,
  BotaoPrimario,
  CampoTexto,
  LinkAuth,
} from './AuthShell';

const SENHA_MINIMA = 8;

export default function RedefinirSenhaPage() {
  const [senha, setSenha] = useState('');
  const [confirmacao, setConfirmacao] = useState('');
  const [erros, setErros] = useState({});
  const [erroGeral, setErroGeral] = useState('');
  const [carregando, setCarregando] = useState(false);

  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const { redefinirSenha } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErroGeral('');

    const novos = {};
    if (senha.length < SENHA_MINIMA)
      novos.senha = `Use pelo menos ${SENHA_MINIMA} caracteres.`;
    if (senha !== confirmacao) novos.confirmacao = 'As senhas não conferem.';
    setErros(novos);
    if (Object.keys(novos).length > 0) return;

    setCarregando(true);
    try {
      await redefinirSenha(token, senha);
      navigate('/login', { replace: true });
    } catch (err) {
      if (err?.response?.status === 400) {
        setErroGeral(
          'Este link expirou ou já foi usado. Peça um novo link de redefinição.',
        );
      } else {
        setErroGeral('Não foi possível redefinir agora. Tente novamente.');
      }
    } finally {
      setCarregando(false);
    }
  };

  if (!token) {
    return (
      <AuthShell titulo="Link inválido">
        <div className="space-y-5">
          <AlertaErro>
            Este link de redefinição está incompleto. Peça um novo para
            continuar.
          </AlertaErro>
          <BotaoPrimario
            type="button"
            onClick={() => navigate('/esqueci-senha')}
          >
            Pedir novo link
          </BotaoPrimario>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      titulo="Nova senha"
      subtitulo="Escolha uma senha para voltar a acessar sua conta"
      rodape={<LinkAuth to="/login">Voltar para o login</LinkAuth>}
    >
      <form onSubmit={handleSubmit} noValidate className="space-y-5">
        <CampoTexto
          rotulo="Nova senha"
          name="senha"
          type="password"
          autoComplete="new-password"
          autoFocus
          required
          placeholder="••••••••"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          erro={erros.senha}
          dica={`Mínimo de ${SENHA_MINIMA} caracteres.`}
        />

        <CampoTexto
          rotulo="Confirmar nova senha"
          name="confirmacao"
          type="password"
          autoComplete="new-password"
          required
          placeholder="••••••••"
          value={confirmacao}
          onChange={(e) => setConfirmacao(e.target.value)}
          erro={erros.confirmacao}
        />

        <AlertaErro>{erroGeral}</AlertaErro>

        <BotaoPrimario type="submit" carregando={carregando}>
          Redefinir senha
        </BotaoPrimario>
      </form>
    </AuthShell>
  );
}
